const facilityDetailedInfoPanelResources = {
    enrollInFacilityButtonText: 'Enroll in facility'
};
export default facilityDetailedInfoPanelResources;
